// removed by extract-text-webpack-plugin
module.exports = {"popular-container":"popular-container__329eY","h2style":"h2style__3Lyj9","popular-wrapper":"popular-wrapper__dFj32","popular-card":"popular-card__3shMB","popular-currencyName":"popular-currencyName__DbNbS","popular-currencyRatio":"popular-currencyRatio__374so"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/components/Popularconversions/Popularconversions.scss
// module id = 731
// module chunks = 68